package games.polyclub.website.frontend.store.components

import games.polyclub.frontend.lib.messagerenderer.Viewer
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.useEffectOnceAsync
import games.polyclub.message.BuildString
import games.polyclub.message.div
import games.polyclub.message.unaryMinus
import games.polyclub.service.player.id.api.MojangPlayerId
import games.polyclub.service.player.id.api.OnlineMojangPlayerId
import games.polyclub.service.player.id.api.PlayerId
import games.polyclub.service.player.id.api.SystemPlayerId
import games.polyclub.tool.functional.retrying
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.appScope
import react.Props
import react.useState

external interface PlayerNameProps : Props {
    var prefixSkin: Boolean?
    var skinSize: Double?
    var playerId: PlayerId?
}

val PlayerName = SFC<PlayerNameProps> { props ->
    val (playerName, setPlayerName) = useState<String?>(null)

    val playerId = props.playerId
    appScope.useEffectOnceAsync {
        setPlayerName(when (playerId) {
            null -> -"${"Desconhecida"/playerId}" - BuildString(Viewer)
            SystemPlayerId.GIVEAWAY -> SystemPlayerId.GIVEAWAY.systemName
            else -> retrying {
                StoreBff.playerName(playerId)
            }
        })
    }

    if (props.prefixSkin == true) {
        AsyncImg {
            alt = ""
            srcLoader = { StoreBff.avatarUrl(playerId ?: OnlineMojangPlayerId.MHF_Alex) }
            width = props.skinSize ?: 32.0
            height = props.skinSize ?: 32.0
        }
        +" "
    }
    if (playerName != null) {
        +playerName
    } else {
        em {
            +when (playerId) {
                is MojangPlayerId -> playerId.mojangId.toString()
                null -> "??"
                else -> "#${playerId.networkId}"
            }
        }
    }
}
